package com.karyadina.model

import kotlinx.serialization.Serializable

/**
 * Task priority levels
 */
enum class TaskPriority {
    LOW,
    MEDIUM,
    HIGH,
    URGENT
}

/**
 * Task status
 */
enum class TaskStatus {
    TODO,
    IN_PROGRESS,
    COMPLETED,
    CANCELLED
}

/**
 * Task category for students
 */
enum class TaskCategory {
    ASSIGNMENT,
    EXAM_PREP,
    PROJECT,
    READING,
    PRACTICE,
    REVISION,
    OTHER
}

/**
 * Task recurrence
 */
enum class TaskRecurrence {
    NONE,
    DAILY,
    WEEKLY,
    MONTHLY
}

/**
 * Task item
 */
@Serializable
data class Task(
    val id: String,
    val title: String,
    val description: String = "",
    val priority: String = TaskPriority.MEDIUM.name,
    val status: String = TaskStatus.TODO.name,
    val category: String = TaskCategory.OTHER.name,
    val deadline: Long? = null, // timestamp
    val estimatedMinutes: Int? = null,
    val actualMinutes: Int? = null,
    val tags: List<String> = emptyList(),
    val createdAt: Long,
    val updatedAt: Long,
    val completedAt: Long? = null,
    val subject: String? = null,
    val reminderTime: Long? = null,
    val recurrence: String = TaskRecurrence.NONE.name,
    val syncEnabled: Boolean = true // Enable cloud sync for this task
)

/**
 * Task list/project
 */
@Serializable
data class TaskList(
    val id: String,
    val name: String,
    val description: String = "",
    val color: String = "#4CAF50",
    val tasks: List<Task> = emptyList(),
    val createdAt: Long
)

/**
 * Task statistics
 */
@Serializable
data class TaskStats(
    val totalTasks: Int = 0,
    val completedTasks: Int = 0,
    val overdueTasks: Int = 0,
    val todayTasks: Int = 0,
    val weekTasks: Int = 0,
    val completionRate: Float = 0f,
    val averageCompletionTime: Int = 0 // minutes
)
